import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    text: String,
    feedbackText: { type: String, default: "Copied!" }
  }

  copy(event) {
    event.preventDefault()

    // Determine what text to copy:
    // 1. If a 'textValue' is provided in HTML, use that.
    // 2. Otherwise, look for a 'source' target (input or div) and grab its value/text.
    const textToCopy = this.hasTextValue ? this.textValue : this.sourceTarget.value || this.sourceTarget.innerText

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.showFeedback()
    }).catch(() => {
      console.error("Failed to copy to clipboard")
    })
  }

  showFeedback() {
    if (!this.hasButtonTarget) return

    const originalText = this.buttonTarget.innerText
    this.buttonTarget.innerText = this.feedbackTextValue
    this.buttonTarget.disabled = true

    setTimeout(() => {
      this.buttonTarget.innerText = originalText
      this.buttonTarget.disabled = false
    }, 2000)
  }
}